import {
  BuyInsuranceProduct,
  ProductForSales,
} from '../stores/products/products-store';
import { CmsProductForSale } from './node/sanity/sanity';

export const getProductId = (product: any) => {
  return isProductRecommended(product)
    ? `${product?.name}-${product?.productLineId}-recommendation`
    : `${product?.name}-${product?.productLineId}`;
};

export const isProductRecommended = (
  product: ProductForSales | CmsProductForSale | BuyInsuranceProduct,
) => {
  if (Object.hasOwn(product, 'modelId')) return true;
  else if (Object.hasOwn(product, 'cmsProductForSale')) {
    return Object.hasOwn(
      'cmsProductForSale' in product && product.cmsProductForSale,
      'modelId',
    );
  }
  return false;
};
